module.exports = __webpack_public_path__ + "assets/img/xinyonghao.3faecc8b.png";